<template>
    <div>
        <div style="display: flex; flex-direction: column">
            <div style="width: 50%;">
                <VueDateFilter @dateFilterChange="dateFilterApplied" />
            </div>
        </div>
        <div v-if="ownedWebsiteTraffic.length === 0" class="alert alert-info" role="alert">
            There is no traffic for the selected filters
        </div>
        <div v-if="!isLoading && ownedWebsiteTraffic.length > 0"  style="display: flex; flex-direction: row; justify-content: center">
            <div style="width: 50%; display: flex; flex-direction: column">
                <table class="table table-striped">
                    <thead>
                    <tr>
                        <th scope="col">#</th>
                        <th scope="col">Owned Website</th>
                        <th scope="col">Iframe Traffic</th>
                        <th scope="col">Pixel Traffic</th>
                        <th scope="col">Generated Traffic</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(row, index) in paginatedItems">
                        <th scope="row">{{index + 1}}</th>
                        <td>{{ row.name }}</td>
                        <td>{{ row.iframes }}</td>
                        <td>{{ row.pixels }}</td>
                        <td>{{ row.total_traffic }} of {{ allTraffic }} <span class="badge">{{ calculatePercentage(row.total_traffic) }} % </span></td>
                    </tr>

                    </tbody>
                </table>
                <Pagination
                    @pageChange="changePage"
                    :page-count="pageCount"
                />
            </div>
            <div style="width: 50%; display:flex; justify-content: center">
                <BarChart :data="chartData"  />
            </div>
        </div>
        <div v-if="isLoading" class="loader" id="loader-1"></div>

    </div>
</template>

<script>
import VueDateFilter from "../../generic/VueDateFilter";
import Pagination from "../../common/Pagination";
import BarChart from "../charts/BarChart";

const PER_PAGE = 10;

export default {
    name: "TrafficLogOwnedWebsiteReport",
    components: {BarChart, Pagination, VueDateFilter},
    data() {
        return {
            filters: {
                start: null,
                end: null,
                owned_website_id: null,
            },
            ownedWebsiteTraffic: [],
            allTraffic: 0,
            isLoading: false,
            pageCount: 0,
            pageNumber: 0,
        }
    },
    computed: {
        chartData() {
          return {
              labels: this.ownedWebsiteTraffic.map(item => item.name),
              datasets: [
                  {
                      label: "Total Traffic",
                      backgroundColor: "#00008B",
                      data: this.ownedWebsiteTraffic.map(item => item.total_traffic)
                  },
                  {
                      label: "Pixels Traffic",
                      backgroundColor: "#008000",
                      data: this.ownedWebsiteTraffic.map(item => item.pixels)
                  },
                  {
                      label: "IFrame Traffic",
                      backgroundColor: "#FF0000",
                      data: this.ownedWebsiteTraffic.map(item => item.iframes)
                  },
              ]
          };
        },
        paginatedItems() {
            const start = this.pageNumber * PER_PAGE,
                end = start + PER_PAGE;

            return this.ownedWebsiteTraffic.slice(start, end);
        }
    },
    methods: {
        dateFilterApplied(dateFromTimestamp, dateToTimestamp, type) {
            this.filters.start = dateFromTimestamp;
            this.filters.end = dateToTimestamp;
            this.fetch()
        },

        fetch() {
            const filters = this.filters;
            this.isLoading = true;
            axios.post('traffic-log-owned-website-report/getReport', filters).then((res) => {
                this.isLoading = false;
                this.ownedWebsiteTraffic = res.data.owned_website_traffic;
                this.allTraffic = res.data.traffic_count[0];
                this.pageCount = Math.ceil(res.data.owned_website_traffic.length / PER_PAGE);

            }).catch(({response, request}) => {
                if(response.data && response.data.errors) {
                    for (const property in response.data.errors) {
                    }
                }
                this.isLoading = false;
            })
        },

        calculatePercentage(traffic) {
            return ((traffic / this.allTraffic) * 100).toFixed(2);
        },

        changePage(fromPage, toPage) {
            this.pageNumber = toPage;
        },
    }
}
</script>

<style scoped lang="scss">
    @import "../../../../../sass/admin-panel/partials/_loader.scss";
</style>



// WEBPACK FOOTER //
// resources/js/admin-panel/components/admin/traffic-log-owned-website-report/TrafficLogOwnedWebsiteReport.vue